import { render, staticRenderFns } from "./userpopover.vue?vue&type=template&id=d0c6d672&scoped=true&"
import script from "./userpopover.vue?vue&type=script&lang=js&"
export * from "./userpopover.vue?vue&type=script&lang=js&"
import style0 from "./userpopover.vue?vue&type=style&index=0&id=d0c6d672&prod&lang=scss&scoped=true&"
import style1 from "./userpopover.vue?vue&type=style&index=1&id=d0c6d672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c6d672",
  null
  
)

export default component.exports